import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA LE PROVE SPECIALI ZANICHELLI',
        description: "Trovi le prove comuni e le prove d'ingresso che la redazione ti propone.",
        name: 'SpecialNavItem',
        tutorialName: 'verifica_tab-prove-speciali-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 0
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 0
    }
};
